import React, { useEffect, useState } from 'react';
import { TRANSPORT_SAVE_API, TRANSPORT_SEARCH_API, TRANSPORT_SUB_SAVE_API } from '../../config/api';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';

function TransportNew() {
  // --- State for tabs ---
  const [activeTab, setActiveTab] = useState('transporter');

  // --- Transporter form ---
  const [form, setForm] = useState({
    name: '',
    contact_person: '',
    phone: '',
    email: ''
  });
  const [success, setSuccess] = useState(null);

  // --- Sub-Transporter form ---
  const [subForm, setSubForm] = useState({
    transporter_id: '',
    name: '',
    contact_person: '',
    mobile: '',
    email: ''
  });
  const [subSuccess, setSubSuccess] = useState(null);

  // --- Transporter list for dropdown ---
  const [transporterList, setTransporterList] = useState([]);

  useEffect(() => {
    fetchTransporters();
  }, []);

  const fetchTransporters = async () => {
    try {
      const res = await fetch(TRANSPORT_SEARCH_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: 1 }) // Replace with real user_id
      });
      const data = await res.json();
      if (data.success) {
        setTransporterList(data.records || []);
      }
    } catch (err) {
      console.error('Error loading transporters', err);
    }
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubChange = e => {
    setSubForm({ ...subForm, [e.target.name]: e.target.value });
  };

  const handleTransporterSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch(TRANSPORT_SAVE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, user_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        setSuccess('Transporter added successfully!');
        setForm({ name: '', contact_person: '', phone: '', email: '' });
        fetchTransporters(); // refresh list
      } else {
        setSuccess('Failed to save transporter. I Think you entered duplicate transporter name.');
      }
    } catch (err) {
      setSuccess('Error while saving.');
    }
  };

  const handleSubTransporterSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch(TRANSPORT_SUB_SAVE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...subForm, user_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        setSubSuccess('Sub-Transporter added successfully!');
        setSubForm({ transporter_id: '', name: '', contact_person: '', mobile: '', email: '' });
      } else {
        setSubSuccess('Failed to save sub-transporter.');
      }
    } catch (err) {
      setSubSuccess('Error while saving.');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4>Add Transporter / Sub-Transporter</h4>
        <ul className="nav nav-tabs mt-3">
          <li className="nav-item">
            <button className={`nav-link ${activeTab === 'transporter' ? 'active' : ''}`} onClick={() => setActiveTab('transporter')}>
              Add Transporter
            </button>
          </li>
          <li className="nav-item">
            <button
  className={`nav-link ${activeTab === 'sub' ? 'active' : ''}`}
  onClick={() => {
    setActiveTab('sub');
    fetchTransporters(); // fetch latest transporter list when opening Sub tab
  }}
>

              Add Sub-Transporter
            </button>
          </li>
        </ul>

        <div className="tab-content p-3 border border-top-0">
          {activeTab === 'transporter' && (
            <form onSubmit={handleTransporterSubmit}>
              <div className="mb-3">
                <label className="form-label">Transporter Name</label>
                <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Contact Person</label>
                <input type="text" className="form-control" name="contact_person" value={form.contact_person} onChange={handleChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone</label>
                <input type="text" className="form-control" name="phone" value={form.phone} onChange={handleChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} />
              </div>
              <button type="submit" className="btn btn-primary">Save</button>
              {success && <div className="mt-3 alert alert-info">{success}</div>}
            </form>
          )}

          {activeTab === 'sub' && (
            <form onSubmit={handleSubTransporterSubmit}>
              <div className="mb-3">
                <label className="form-label">Select Transporter</label>
                <select className="form-select" name="transporter_id" value={subForm.transporter_id} onChange={handleSubChange} required>
                  <option value="">-- Select --</option>
                  {transporterList.map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Sub-Transporter Name</label>
                <input type="text" className="form-control" name="name" value={subForm.name} onChange={handleSubChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Contact Person</label>
                <input type="text" className="form-control" name="contact_person" value={subForm.contact_person} onChange={handleSubChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">Mobile</label>
                <input type="text" className="form-control" name="mobile" value={subForm.mobile} onChange={handleSubChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" name="email" value={subForm.email} onChange={handleSubChange} />
              </div>
              <button type="submit" className="btn btn-primary">Save Sub-Transporter</button>
              {subSuccess && <div className="mt-3 alert alert-info">{subSuccess}</div>}
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TransportNew;
